import { auto } from '@popperjs/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);
import SliderPlugin from './slider-plugin';

class VideoSliderPlugin extends SliderPlugin {

    static type: String = "videos";

    constructor(element: HTMLElement) {
        super(element);
    }

    init() {
        let buttons = this.getButtons();
        this.swiper = new Swiper(this.getClassPath(), {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: false,
            pagination: {
                el: ".video-slider-pagination" + buttons.pagiBtn,
                clickable: true,
            },
            navigation: {
                nextEl: ".video-slider-next-btn" + buttons.nextBtn,
                prevEl: ".video-slider-prev-btn" + buttons.prevBtn,
            },
        });
    }
}

export default VideoSliderPlugin;